<div class="modal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="loading-screen" *ngIf="!(isLoading$ | async)">
        <div class="loading">
            <div id="loader"></div>
            <div class="loading-content">
              <p>
                Loading Notification...
              </p>
            </div>
        </div>
      </div>
      <div class="modal-header">
        <h4 class="pagetitle">Notifications
          <div class="pagetitle-slogan">Click link under Next Action to proceed to the next action</div>
        </h4>
        <span
          class="table-material-icons close-button"
          (click)="activeModal.dismiss('Cross click')"
          (keydown)="activeModal.dismiss('Cross click')"
          >close</span
        >
      </div>
      <div class="modal-body notification-body">
        <div *ngIf="(notifications$ | async) > 0; else noNotifications">
          <mat-tab-group
            mat-stretch-tabs="false"
            mat-align-tabs="start"
            [selectedIndex]="activeTabIndex"
            *ngIf="(notificationList$ | async) as notifications"
          >
            <mat-tab [disabled]="!(notifications.approval_pending?.length > 0)">
              <ng-template mat-tab-label>
                Not Started Forms
                <span *ngIf="notifications.approval_pending?.length > 0"
                      class="notification-bubble">{{ notifications.approval_pending?.length }}
                </span>
              </ng-template>
              <div class="tab-content">
                <table class="styled-table mat-elevation-z8 notification-table">
                  <thead>
                    <tr>
                      <th>PRF Number</th>
                      <th colspan="2">PRF Name</th>
                      <th>Next Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of notifications.approval_pending">
                      <td class="text-bold">{{ item.compno }}</td>
                      <td>{{ item.compname }}</td>
                      <td><p class="status-text">{{ item.days_gap }} days in not started.</p></td>
                      <td><a
                        role="button"
                        [routerLink]="['/' + currentYear + '/' + item.compno + '/' +item.nextStep]"
                        (click)="openPRF()"
                        (keydown)="openPRF()"
                         tabindex="0"
                      class="confirm-address-link">Confirm Information</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </mat-tab>

            <!-- Tab 2: Submission Pending -->
            <mat-tab [disabled]="!(notifications.submission_pending?.length > 0)">
              <ng-template mat-tab-label>
                Submission Pending
                <span *ngIf="notifications.submission_pending?.length > 0"
                      class="notification-bubble">{{ notifications.submission_pending?.length }}
                </span>
              </ng-template>
              <div class="tab-content">
                <table class="styled-table mat-elevation-z8 notification-table">
                  <thead>
                    <tr>
                      <th>PRF Number</th>
                      <th colspan="2">PRF Name</th>
                      <th>Next Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of notifications.submission_pending">
                      <td class="text-bold">{{ item.compno }}</td>
                      <td>{{ item.compname }}</td>
                      <td><p class="status-text">{{ item.days_gap }} days since the form started.</p></td>
                      <td><a
                        role="button"
                        [routerLink]="['/' + currentYear + '/' + item.compno + '/' +item.nextStep]"
                        (click)="openPRF()"
                        (keydown)="openPRF()"
                         tabindex="0"
                        class="confirm-address-link">
                        {{
                          item.nextStep === 'groupreporting' ? 'Group Reporting' :
                          item.nextStep === 'premiumreport' ? 'Premium Report' :
                          item.nextStep === 'annualstatement' ? 'Annual Statement' :
                          item.nextStep === 'userdefineddata' ? 'User Defined Data' :
                          'Premium Report'
                        }}
                      </a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </mat-tab>

            <!-- Tab 3: Validation Feedback Pending -->
            <mat-tab [disabled]="!(notifications.validation_pending?.length > 0)">
              <ng-template mat-tab-label>
                Validation Warning
                <span *ngIf="notifications.validation_pending?.length > 0"
                      class="notification-bubble">
                      {{ notifications.validation_pending?.length }}
                </span>
              </ng-template>
              <div class="tab-content">
                <table class="styled-table mat-elevation-z8 notification-table">
                  <thead>
                    <tr>
                      <th>PRF Number</th>
                      <th colspan="2">PRF Name</th>
                      <th>Next Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of notifications.validation_pending">
                      <td class="text-bold">{{ item.compno }}</td>
                      <td>{{ item.compname }}</td>
                      <td><p class="status-text">{{ item.days_gap }} days in validating state.</p></td>
                      <td><a
                        role="button"
                        [routerLink]="['/' + currentYear + '/' + item.compno + '/' +item.nextStep]"
                        (click)="openPRF()"
                        (keydown)="openPRF()"
                         tabindex="0"
                        class="confirm-address-link">
                        Validation Summary
                      </a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
        <ng-template #noNotifications>
          <div class="no-notifications">
            <mat-icon class="no-notifications-icon">notifications_off</mat-icon>
            <p class="no-notifications-text">No Notifications Available</p>
          </div>
        </ng-template>
      </div>
      <div class="modal-footer">
        <app-button
          size="medium"
          (click)="activeModal.dismiss('Cross click')"
          (keydown)="activeModal.dismiss('Cross click')"
          buttonType="secondary"
        >
          Close</app-button
        >
      </div>
    </div>
  </div>
</div>
